import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import logo from "../assets/logo.png";
import "./Navbar.scss";
// import { FaSearch } from "react-icons/fa";
// import { ShoppingCart } from "lucide-react"; 

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [showSearch, setShowSearch] = useState(false);

  const navigate = useNavigate();

  // useEffect(() => {
  //   const handleScroll = () => setIsScrolled(window.scrollY > 50);
  //   window.addEventListener("scroll", handleScroll);
  //   return () => window.removeEventListener("scroll", handleScroll);
  // }, []);

  const toggleMobileMenu = () => setIsMobileMenuOpen(!isMobileMenuOpen);
  // const toggleSearch = () => setShowSearch(!showSearch);

  // const handleSearch = (e) => {
  //   if (e.key === "Enter") {
  //     if (searchTerm.trim() !== "") {
  //       navigate(`/collection?search=${searchTerm}`);
  //     }
  //   }
  // };

  return (
    <nav className={`navbar ${isScrolled ? "navbar-scrolled" : ""}`}>
      <div className="container">
        <div className="navbar-content">
          {/* Logo */}
          <Link to="/" className="navbar-logo">
            <img src={logo} alt="Swarna Shringar" className="logo-image" />
          </Link>

          {/* Search */}
          {/* <div className="search-container" style={{ position: "relative" }}>
            <FaSearch className="search-icon" />

            <input
              type="text"
              placeholder="Search for Bridal Jewelry and more..."
              className="search-input"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              onKeyDown={handleSearch}
              autoFocus
            />
          </div> */}

          {/* Desktop Navigation */}
          <ul
            className={`navbar-menu ${
              isMobileMenuOpen ? "navbar-menu-open" : ""
            }`}
          >
            <li className="navbar-item">
              <Link to="/" className="navbar-link">
                Home
              </Link>
            </li>
            <li className="navbar-item">
              <Link to="/collections" className="navbar-link">
                Collections
              </Link>
            </li>
            <li className="navbar-item">
              <Link to="/about" className="navbar-link">
                About
              </Link>
            </li>
            <li className="navbar-item">
              <Link to="/contact" className="navbar-link">
                Contact
              </Link>
            </li>
          </ul>

          {/* Mobile Menu Button */}
          <button
            className={`mobile-menu-btn ${
              isMobileMenuOpen ? "mobile-menu-btn-open" : ""
            }`}
            onClick={toggleMobileMenu}
            aria-label="Toggle mobile menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
